namespace GeniuzPOS.Lookups {
    export interface SysCountryRow {
        Id?: number;
        CountryCode?: string;
        CountryName?: string;
        NationName?: string;
        CounTinent?: number;
        CounShowCode?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace SysCountryRow {
        export const idProperty = 'CounShowCode';
        export const nameProperty = 'CountryName';
        export const localTextPrefix = 'Lookups.SysCountry';
        export const lookupKey = 'SysCountryRow';

        export function getLookup(): Q.Lookup<SysCountryRow> {
            return Q.getLookup<SysCountryRow>('SysCountryRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            CountryCode = "CountryCode",
            CountryName = "CountryName",
            NationName = "NationName",
            CounTinent = "CounTinent",
            CounShowCode = "CounShowCode",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
